// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".photo[data-v-3c234a5a]{width:100%;padding:4px;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);-webkit-box-shadow:0 1px 3px rgba(0,0,0,.1);box-shadow:0 1px 3px rgba(0,0,0,.1);margin-bottom:30px}.gap[data-v-3c234a5a]{-webkit-column-gap:30px;-moz-column-gap:30px;column-gap:30px}", ""]);
// Exports
module.exports = exports;
